import React from "react"; 
import "./SigninGuide.css"; // Ensure the CSS file exists

const SignInGuide = () => {
  return (
    <div className="container">
      <div className="card">
        <h1 className="title">How Can I Sign in to Gatnix Time Sheets?</h1>

        {/* Step 1 */}
        <div className="step">
          <h2>Step 1:</h2>
          <p>
            To sign in to your Gatnix account, go to{" "}
            <a
              href="https://timesheet.gatnix.com"
              className="link"
              target="_blank"
              rel="noopener noreferrer"
            >
              timesheet.gatnix.com
            </a>{" "}
            or select <b>Sign in</b> below.
          </p>
          <a href="https://timesheet.gatnix.com/signin" className="btn">
            Sign in
          </a>
          <p className="tip">
            Tip: If you don't have a Gatnix account, select{" "}
            <b>"No account? Create one!"</b>
          </p>
        </div>

        {/* Step 2 */}
        <div className="step">
          <h2>Step 2:</h2>
          <p>
            Enter your <b>Organization Name, Email, and Phone Number</b> and click <b>Next</b>.
          </p>
          <p className="tip">
            Tip: On the next page, fill in your details (Address, City, State, Pin Code).
          </p>
        </div>

        {/* Step 3 */}
        <div className="step">
          <h2>Step 3:</h2>
          <p>
            Verify your <b>Email OTP</b> and <b>Mobile OTP</b>, then click <b>Next</b>.
          </p>
          <p className="tip">
            Tip: Enter a valid OTP and use the correct Email & Phone Number to proceed to Super Admin Registration.
          </p>
        </div>

        {/* Step 4 */}
        <div className="step">
          <h2>Step 4:</h2>
          <p>
            Enter your <b>First Name, Last Name, Phone Number, WhatsApp Number, Email, and Password</b>. You will then sign in to the Super Admin Dashboard.
          </p>
        </div>

        {/* Help Desk Note */}
        <div className="note">
          <p>
            <b>Note:</b> If you can’t sign in, contact our <b>Help Desk</b>, and our team will assist you.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignInGuide;
